import { LOADING_STATUS } from "../../models";

import * as actionTypes from "./constants";

import type { CPTModifiersActions } from "./actions";
import type { CPTModifiersState, ModifierCollection } from "./models";

const createEmptyCPTModifiersState = (): CPTModifiersState => ({
  status: LOADING_STATUS.NOT_LOADED,
  date: "",
  modifiers: [],
});

export const cptModifiersReducer = (
  state = createEmptyCPTModifiersState(),
  action: CPTModifiersActions,
) => {
  switch (action.type) {
    case actionTypes.CPT_MODIFIERS_BEGIN:
      return handleCPTModifiersBegin(state);
    case actionTypes.CPT_MODIFIERS_COMPLETED:
      return handleCPTModifiersCompleted(state, action.payload);
    case actionTypes.CPT_MODIFIERS_ERROR:
      return handleCPTModifiersError(state);
    case actionTypes.CPT_MODIFIERS_CLEAN:
      return createEmptyCPTModifiersState();
    default:
      return state;
  }
};

const handleCPTModifiersBegin = (state: CPTModifiersState) => ({
  ...state,
  status: LOADING_STATUS.LOADING,
});
const handleCPTModifiersCompleted = (
  state: CPTModifiersState,
  payload: {
    modifiers: ModifierCollection[];
    date?: string | undefined;
  },
) => ({
  ...state,
  status: LOADING_STATUS.READY,
  modifiers: [...payload.modifiers],
  date: payload.date,
});

const handleCPTModifiersError = (state: CPTModifiersState) => ({
  ...state,
  status: LOADING_STATUS.ERROR,
});
